import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-tai-chi-walking-v2': {
			// Variant B: question counter
			// ?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_tai_chi_fem_v2_questions_counter~1
			funnel: {
				id: 'ob-female-tai-chi-walking-v2-questions-counter',
				locale: ['en'],
			},
		},
	},
	{
		'activity-female-tai-chi-walking-v2': {
			// Variant C: progress percent
			// ?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_tai_chi_fem_v2_questions_counter~2
			funnel: {
				id: 'ob-female-tai-chi-walking-v2-progress-percent',
				locale: ['en'],
			},
		},
	},
]

export default config
